import { type ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { useMotivationalStats } from '../hooks/use-motivational-stats';
import { MotivationalCards } from './motivational-cards';

export function CollectorMotivation({
  collectorId,
}: {
  collectorId: string;
}): ReactNode {
  const { data, isLoading } = useMotivationalStats(collectorId);
  if (isLoading) {
    return (
      <div className="grid gap-sm md:grid-cols-3">
        {Array.from({ length: 3 }, (_, i) => (
          <Skeleton key={i} className="h-16 rounded-xl" />
        ))}
      </div>
    );
  }
  if (!data) return null;
  return (
    <MotivationalCards
      weekDiff={data.weekDiff}
      nextRankGap={data.nextRankGap}
      streak={data.streak}
    />
  );
}
